import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";

const MainTable = () => (
  <LmsTable
    deleteSuffix="salesteam"
    sortable={["Created On"]}
    apiSuffix="salesteam/regional-sales-managers"
    actionButtons={["add", "edit", "remove", "export"]}
    columnLabelsDictionary={{ bypassOrganizationContact: "Bypass Recipient" }}
  />
);

const RegionalSalesManagerForm = ({ id }) => {
  const [{ data = { enableNotificationBypass: false }, isLoading, error }] = useFetchData(
    id ? `salesteam/regional-sales-manager-info/${id}` : ""
  );

  const handleRegionChanged = async ({ value, fetchData, setInputs }) => {
    if (id) {
      const { data } = await fetchData(`/salesteam/regions/${value}/info`);
      if (data.existingRegionalSalesManager) {
        setInputs((prevInputs) => ({
          ...prevInputs,
          existingRegionalSalesManager: `${data.existingRegionalSalesManager} will be deleted`,
        }));
      }
    }
  };

  const myForm = new BCFormController(data, {
    submitSuffix: "salesteam/regional-sales-manager",
    submitMethod: id ? "PUT" : "POST",
  });

  myForm.addCenteredGroup([
    myForm.getDropdownField("Regional Sales Manager", "salesteam/list-regional-sales-manager", {
      name: "organizationContactId",
      required: true,
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Region", id ? "metadata/list-region" : "salesteam/list-region", {
      name: "regionId",
      required: true,
      onFieldChanged: handleRegionChanged,
    }),
  ]);

  myForm.addCenteredGroup(
    [myForm.getDisplayField("Existing Regional Sales Manager", { noBackground: true })],
    {
      isHiddenFunc: ({ inputs }) => !inputs.existingRegionalSalesManager,
    }
  );

  myForm.addCenteredGroup([
    myForm.getInputField("Enable Notification Bypass", {
      name: "enableNotificationBypass",
      field: "checkbox",
      inline: true,
    }),
  ]);

  myForm.addCenteredGroup(
    [
      myForm.getDropdownField("Bypass Recipient", "salesteam/list-bypass-recipient", {
        name: "bypassOrganizationContactId",
      }),
    ],
    { isHidden: { enableNotificationBypass: false }, isHiddenOperation: "notequal" }
  );

  myForm.addCenteredGroup(
    [
      myForm.getDropdownField("Bypass Recipient", "salesteam/list-bypass-recipient", {
        name: "bypassOrganizationContactId",
        required: true,
      }),
    ],
    { isHidden: { enableNotificationBypass: true }, isHiddenOperation: "notequal" }
  );

  return (
    <LmsFormGenerator
      myForm={myForm}
      isLoading={isLoading}
      error={error}
      actions={["save-close", "close"]}
    />
  );
};

const LmsSalesTeamRegionalSalesManager = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <MainTable />}
      {(isAdd || isEdit) && <RegionalSalesManagerForm id={id} />}
    </>
  );
};

export default LmsSalesTeamRegionalSalesManager;
